/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LiveSessionLinks from 'ui/components/live-session/LiveSessionLinks.vue';

const __vue_script__ = {
    name: 'LiveSessionActions',

    components: {
        LiveSessionLinks
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        item: {
            type: Object,
            required: true
        }
    },

    computed: {
        areLinksAvailable() {
            const statesWithAvailableLinks = ['RESERVING', 'IDLE', 'SCHEDULED', 'STARTING', 'RUNNING'];
            const isLivestreamInValidState = !this.item.fp_system || statesWithAvailableLinks.includes(this.item.fp_system.state);
            return !this.item.is_third_party && isLivestreamInValidState;
        },

        downloadUrl() {
            return this.$services.liveStream.getDownloadUrl(this.event._id, this.item);
        },

        isDeleteAvailable() {
            const canDelete = this.$services.user.hasPermission('live_stream.manage_stream', {
                event_id: this.event._id,
                org_id: this.event.owner_id
            });

            const liveStreamState = this.item.fp_system?.state ?? 'SCHEDULED';
            const isDeletableState = ['SCHEDULED', 'RELEASED'].includes(liveStreamState);

            return canDelete && (this.item.is_third_party || isDeletableState) || this.$services.user.isSuperAdmin();
        }
    },

    methods: {
        promptDeletion() {
            this.$modal.show('dialog', {
                title: this.$t('live_sessions.actions.delete'),
                text: this.$t('live_sessions.list.messages.prompt_deletes'),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            this.deleteLiveStream();
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        async deleteLiveStream() {
            try {
                await this.$services.liveStream.deleteDoc(this.event._id, this.item._id);
                this.$notify({
                    group: 'flashes',
                    text: this.$tc('listings.messages.items_deleted', 1).toString(),
                    type: 'success',
                    duration: 5000
                });
            } catch (error) {
                if (this.$services.user.isSuperAdmin()) {
                    const { _id: eid, node } = this.event;
                    const { _id, fp_type } = this.item;
                    this.$services.documents.deleteDocs(eid, node, fp_type, _id);
                }

                if (error.response?.status === 400) {
                    // Backend returns this HTTP error code when the live stream is not in SCHEDULED state
                    this.$emit('error', this.$t('live_sessions.list.messages.delete_error'));
                } else {
                    this.$emit('error', this.$t('live_sessions.list.messages.remove_error'));
                }
            } finally {
                this.$emit('deleted');
            }
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-session-actions"},[(_vm.areLinksAvailable)?_c('live-session-links',{attrs:{"item":_vm.item,"event":_vm.event},on:{"error":function($event){return _vm.$emit('error', $event)}}}):_vm._e(),(_vm.downloadUrl)?_c('a',{staticClass:"btn btn-icon single btn-primary",attrs:{"href":_vm.downloadUrl,"target":"_blank","download":"download"}},[_c('i',{staticClass:"ic-download"})]):_vm._e(),(_vm.isDeleteAvailable)?_c('button',{staticClass:"btn btn-icon single btn-danger",attrs:{"type":"button","aria-label":_vm.$t('general.delete')},on:{"click":function($event){return _vm.promptDeletion()}}},[_c('i',{staticClass:"ic-trash-2"})]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LiveSessionActions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__